<template>
<div v-if="isShow">
    <header>{{ title }}<div class="h-left"><a @click="$emit('close'); isOpenSendContactForm = false;"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="txt-area" id="other_site_content" v-html="content">
        </div>
        <div class="txt-area" v-if="siteName == 'help_page'">
            <div class="btn4" id="send_contact_btn"><a @click="showSendContactForm(); isShow = false">その他のお問い合わせはこちら</a></div>
        </div>
    </div>
</div>

<div v-if="isSendContactForm">
   <header>お問い合わせフォーム<div class="h-left"><a @click="isSendContactForm = false; isShow = true;"><img src="~@/assets/images/icon02.svg"></a></div>
   </header>
   <div id="wrap" style="height: 100%; overflow: hidden;">

        <div class="txt-area">
            <p>「よくあるお問い合わせ」を読んでも解決しない場合は、以下よりお問い合わせください。<br>
                お問い合わせ受付：24時間365日<br>
                送信対応時間　　：平日10:00～19:00<br>
            </p>
        </div>

        <div class="txt-area" style="padding-bottom: 0px;">
            <p class="b">お問い合わせカテゴリー</p>
        </div>
        <div class="real-select">
            <select v-model="category" required :style="validate(category, 'category') ? validate(category, 'category').style : ''">
                <option :value="null" selected disabled>選択してください</option>
                <option v-for="(item, index) in metadata.contact_categories" :key="index" :value="item['id']">{{ item['name'] }}</option>
            </select>
            <span style="color:red; padding-left: 12.5px;" v-if="validate(category, 'category')">{{ validate(category, 'category').message }}</span>
        </div>

        <div class="txt-area">
            <p class="b">お問い合わせ内容</p>
            <textarea :style="validate(comment, 'comment') ? validate(comment, 'comment').style : ''" required v-model="comment" class="self-introduction1"></textarea>
            <span style="color:red" v-if="validate(comment, 'comment')">{{ validate(comment, 'comment').message }}</span>
        </div>

        <div class="txt-area">
            <p>ご回答までに2営業日程度お時間いただく場合がございます。<br>
            予めご了承くださいませ。<br>
            </p>
        </div>
        <div class="btn1"><a @click="submit">送信する</a></div>
   </div>
</div>

<successDialog :active="isSuccess" @close="isSendContactForm = false; isShow = true; isSuccess = false; resetForm()">
    <template v-slot:message>
        <p class="sent-contact-title">
            お問い合わせの送信が完了しました。
        </p>
        <br>
        <div class="sent-contact-content">
            <p style="margin-bottom: 5px;">
                お問い合わせ内容は、48時間以内に確認して返答させて頂きます。
            </p>
            <p>※返信対応時間：</p>
            <p>平日10：00〜19：00</p>
        </div>
    </template>
</successDialog>

</template>

<script>
import {
  mapGetters
} from "vuex"

import CONSTANTS from "@/constants"
import successDialog from '@/views/components/successDialog'

export default {
    props: {
        isShow: Boolean,
        siteName: String
    },
    components: {
        successDialog
    },
    emits: ['close'],
    data: () => ({
        isSubmit: false,
        comment: null,
        title: null,
        content: null,
        isSendContactForm: false,
        isOpenSendContactForm: false,
        category: null,
        isValidate: false,
        isSuccess: false,
        scrollPosition: 0,
        isTrackKeyboard: false,
        isKeyboardOpen: false,
    }),
    computed: {
        ...mapGetters(["metadata", 'defaultToken', "userDetail"]),
    },
    watch: {
        isShow(val) {
            if (val && !this.isOpenSendContactForm) {
                this.showOtherSites(this.siteName)
            }
        },
        category(data) {
            if (data && this.comment) {
                this.isSubmit = true
            } else {
                this.isSubmit = false
            }
        },
        comment(data) {
            if (data && this.category) {
                this.isSubmit = true
            } else {
                this.isSubmit = false
            }
        },
        isSendContactForm(val) {
            // Scroll to top when open Contact Form
            if (val) {
                this.setScrollPosition();
                document.getElementById("child").scrollTo(0, 0)
            } else {
                setTimeout(() => {
                    document.getElementById("child").scrollTo(0, this.scrollPosition)
                }, 10)
            }
        } 
    },
    updated() {
        if (this.isSendContactForm && !this.isTrackKeyboard) {
            window.visualViewport.addEventListener('resize', event => {
                if (document.documentElement.clientHeight > window.visualViewport.height) {
                    this.isKeyboardOpen = true
                } else {
                    if (this.isKeyboardOpen) {
                        setTimeout(() => {
                            window.scrollTo(0, 0);
                        }, 1);
                        this.isKeyboardOpen = false
                    }
                }
            });
            this.isTrackKeyboard = true
        }
    },
    destroyed() {
        window.visualViewport.removeEventListener('resize');
    },
    methods: {
        async showOtherSites(site) {
            this.content = null;

            let slug = "";
            if (site == "operating_company") {
                slug = "company_page";
            } else if (site == "terms_of_use") {
                slug = "security_page";
            } else if (site == "privacy_policy") {
                slug = "privacy_policy";
            } else if (site == "commercial_law_show") {
                slug = "legal_1";
            } else if (site == "fund_law_show") {
                slug = "legal_2";
            } else if (site == "guide") {
                slug = "guide";
            } else if (site == "help_page") {
                if (parseInt(this.userDetail.sex) === CONSTANTS.MALE) {
                    slug = "help_page_male"
                } else {
                    slug = "help_page_female"
                }
            }
            

            let pages = this.metadata.pages.result;
            for (var page of pages) {
                if (page.slug == slug) {
                    this.title = page.title
                    break
                }
            }
            let site_content = '';
            if (process.env.NODE_EN == 'production') {
                site_content = CONSTANTS.CONTENT_URL_LIVE + 'content/greedgreed/' + slug;
            } else {
                site_content = CONSTANTS.CONTENT_URL_STG + 'content/greed-greed-stg/' + slug;   // gg.widocom.com
                // site_content = CONSTANTS.CONTENT_URL_STG + 'content/greed_greed_dev/' + slug;      // ggdev.widocom.com
            }
            
            await this.$store
                .dispatch("user/loadPage", site_content)
                .then((data) => {
                    this.content = data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        showSendContactForm() {
            this.isSendContactForm = true
            this.isOpenSendContactForm = true
        },

        validate(value, field) {
            if (!this.isValidate) return
            if (field === 'category') {
                if (!value) {
                    return {
                        style: "border-color: red;",
                        message: "エラーです"
                    }
                }
            }
            if (field === 'comment') {
                if (!value) {
                    return {
                        style: "border-color: red",
                        message: "エラーです"
                    }
                }
            }
            return
        },

        async submit() {
            this.isValidate = true
            if (!this.isSubmit) return
            let formData = new FormData()
            formData.append('user_id', this.userDetail.id)
            formData.append('category_id', this.category)
            formData.append('content', this.comment)
            formData.append('email', '')
            formData.append('token', this.defaultToken)

            await this.$store.dispatch('user/sendContact', formData).then(data => {
                this.isSuccess = true

                // Disable vailate before reset form
                this.isValidate = false
            }).catch(err => {
                console.log(err)
            })
        },

        setScrollPosition() {
            this.scrollPosition = document.getElementById("child").scrollTop;
        },

        resetForm() {
            this.category = null;
            this.comment = null;
        }
    },
};
</script>

<style scoped>
.sent-contact-content p {
    white-space: break-spaces;
    margin-left: 18px;
    text-align: left;
    width: 85%;
}

.sent-contact-title {
    font-size: 17px;
    text-align: left;
    margin-left: 18px;
}
</style>
